export { default as EconomicActivity } from './economic-activity';
